import m from 'mithril';
import _ from "underscore";
import $ from "jquery";

import reactive = require('../model/reactive');
import {elementView} from './elementView'
import {Questionary} from "../model/questionary";
import {Form} from "../model/form/form";
import {ProjectStorage} from "./projectStorage";

export interface Customization {
    register(type: string, id: string, dependencies: string[], factory: any): any;
    getForm(questionary: Questionary, form: Form): Form|null;
}

let forms: { [name: string]: any } = {};

const libraries = {
    mithril: m,
    underscore: _,
    jQuery: $,
    elementView: elementView
};

function resolveDependencies(definitions:{[name:string]: any}, names:string[]): any[] {
     const resolved = [];
     for (let name of names) {
         if (definitions.hasOwnProperty(name)) {
            resolved.push(definitions[name]);
         } else {
             throw Error("FormCustomization: Dependency "+name+" cannot be resolved.");
         }
     }
     return resolved;
}

function variables(q: Questionary) {
    return {
        'set': (name: string, value: any) => q.variableByName(name)(value),
        'get': (name: string) => q.variableByName(name)(),
        'observe': (name: string, callback: any) => {
            const v = q.variableByName(name);
            reactive.bind(()=> { callback(v()); }, [v]);
        }
    };
}

/**
 * Questionary API - Functions to be called from customizations
 */
function questionaryApi(questionary: Questionary, form: Form) {
    return {
        /**
         * Called just before the form is to be submitted.
         * @returns boolean false when submit should be cancelled
         */
        registerPreSubmitCallback: (cb: () => boolean) => questionary.registerFormPreSubmitCallback(form, cb),
        getAttributes: () => questionary.state.attributes,
        /**
         * Generate URL to access questionary media (images). Result can be used in href of <img>
         * @param filename of media file
         * @returns {string} Generated URL
         */
        getFileUrl: (filename: string) => questionary.getFileUrl(filename)
    }
}

export function register(type: string, id: string, dependencies: string[], factory: any) {
    if (type === 'form') {
        if (factory) {
            forms[id] = (questionary: Questionary, form: Form) => {
                const resolved = resolveDependencies(
                    _.extend(
                        {
                            questionary: questionary,
                            form: form,
                            variables: variables(questionary),
                            questionaryApi: questionaryApi(questionary, form),
                            storage: new ProjectStorage(questionary.api.projectId)
                        }, libraries),
                    dependencies
                );

                // @ts-ignore
                return factory.apply(this, resolved);
            }
        }
        return null;
    }
}

export function getForm(questionary: Questionary, form: Form): Form|null {
    const c = forms[form.id];
    return c ? c(questionary, form) : null;
}